<template>
  <section>
    <header>
      <h5>
        Filtrar
      </h5>
    </header>
    <div class="frame fixed">
      <div class="row no-padd" ref="progressaoFilterForm">
        <div class="col-md-2 form-group">
          <label>Período base</label>
          <select-control
            v-model="filter.idPeriodoLetivo"
            :valid="valid.perCodigo" 
            :options="options.periodosLetivos"
            placeholder="Selecione"
            @change="valid.perCodigo = true; setPerBase()"
            required
          />
          <input type="hidden" v-model="filter.perCodigo" />
        </div>
        <div class="col-md-2 form-group">
          <label>Período Progressão</label>
          <input-control 
            v-model="filter.perCodigoNovo"
            :valid="valid.perCodigoNovo" 
            placeholder="2024"
            @keyup="valid.perCodigoNovo = true"
            required
          />
        </div>
        <div class="col-md-2 form-group">
          <label>Progredir Gestor Class</label>
          <div class="switchWrapMini">
            <switch-control v-model:checked="filter.criaPerseus" labelOn="Sim" labelOff="Não" invert />
          </div>
        </div>
        <div class="col-md-12 form-actions form-group">
          <a href="#" @click.prevent="filterProgressao()" class="btn btn-primary">
            Filtrar
          </a>
          <a href="#" @click.prevent="clearFilter()" class="btn btn-secondary">
            Limpar
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FormService from '@/services/form.service.js'
import AcademicoService from '@/services/academico.service.js'
import { createSelectOptions } from '@/services/utils.service.js'
export default {
  data () {
    return {
      filter: {
        idPeriodoLetivo: null,
        perCodigo: null,
        perCodigoNovo: null,
        criaPerseus: 0
      },
      options: {
        periodosLetivos: []
      },
      valid: {
        perCodigo: true,
        perCodigoNovo: true
      }
    }
  },
  mounted () {
    this.getTodosPeriodosLetivos()
  },
  methods: {
    getTodosPeriodosLetivos () {
      window.spinner.emit("open")
      AcademicoService.getTodosPeriodosLetivos().then(
        response => {
          if ( response.data.length > 0 ) {
            console.log("getTodosPeriodosLetivos:", response.data)
            this.options.periodosLetivos = createSelectOptions(response.data, 'idPeriodoLetivo', 'descricao').reverse()
          } else {
            window.toaster.emit('open', {style: "error", message: "Nenhum período letivo encontrado. Isto parece ser um problema de parametrização.", floater: true})
          }
          window.spinner.emit("close")
        },
        () => {
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu! Não foi possível recuperar os períodos letivos necessários", floater: true})
          window.spinner.emit("close")
        }
      )
    },
    filterProgressao () {
      const valid = FormService.validate(this.$refs.progressaoFilterForm, this.valid)

      if ( valid.response ) {
        window.spinner.emit("open")
        const drop = {
          criaPerseus: this.filter.criaPerseus == true ? 1 : 0,
          perCodigo: this.filter.perCodigo,
          perCodigoNovo: this.filter.perCodigoNovo
        }
        console.log("filter:", drop)
        this.$emit('onFilter', drop)
      }
    },
    setPerBase () {
      const idPeriodoLetivo = this.options.periodosLetivos.filter( k => k.idPeriodoLetivo == this.filter.idPeriodoLetivo)[0].descricao
      this.filter.perCodigo = idPeriodoLetivo
    },
    clearFilter () {
      this.filter = {
        idPeriodoLetivo: null,
        perCodigo: null,
        perCodigoNovo: null,
        criaPerseus: 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  header {
    margin: $hmg $hmg_small;
    padding: 0 $hmg_small;

    h5 {
      margin: 0 0 $hmg_mini 0; padding: 0;
    }
    p {
      margin: 0; padding: 0;
    }
  }

  // .frame {
  //   padding: 0 $hmg_small
  // }
  .form-actions {
    margin-top: $hmg !important
  }
</style>